var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box"},[_c('div',{staticClass:"camera"},[_c('div',{staticClass:"title"},[_vm._v("选择类型")]),_c('select',{staticClass:"select"},[_c('option',{attrs:{"value":"0"}},[_vm._v("投影相机")]),_c('option',{attrs:{"value":"0"}},[_vm._v("正交相机")])])])])])
}]

export { render, staticRenderFns }